import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches all invoices from h_vendor_invoices (All Invoice admin view)
 * @returns {Promise<Array>} - API response containing list of all vendor invoices
 */
export const getAllVendorInvoices = async () => {
  try {
    const response = await apiClient.get('/adminInvoiceManagement/invoice/all-vendor-invoices');

    if (response.data?.response && Array.isArray(response.data.response)) {
      return response.data.response;
    }
    return response.data?.response || response.data || [];
  } catch (error) {
    handleApiError(error);
    return [];
  }
};
